import * as React from 'react'
import { inject } from 'mobx-react'
import ProductView from './ProductView'
import LocalizationStore from '../../../Stores/LocalizationStore'
import { IProduct } from '../../../Model/Questionnaire'

export interface IProductListViewProps {
    className?: string
    products: Array<IProduct>
}

@inject('localizationStore')
export default class ProductListlsView extends React.Component<IProductListViewProps> {
    render() {
        const ls = LocalizationStore.getInstance()
        return (
            <div className="container">
                {this.props.products ? this.props.products!.map(productData => {
                    return <ProductView
                        key={productData.externalKey}
                        product={productData}
                        className="row border p-1"
                    />
                }) : (<span>{ls.t!('no products in credits')}</span>)}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/Product/ProductListView.tsx